export default {
      id: "icon-food-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-food",
      toString: function () {
        return this.url;
      }
    }